/**
 * Optimizes image URLs from Unsplash and Pexels by requesting
 * appropriately-sized, compressed, modern-format images.
 */
export function optimizeImageUrl(url, width = 800) {
  if (!url) return url;

  // Use smaller sizes on mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const w = isMobile ? Math.min(width, 400) : width;
  const q = isMobile ? 60 : 75;

  // Unsplash: add w, q, fm params
  if (url.includes('images.unsplash.com')) {
    const u = new URL(url);
    u.searchParams.set('w', String(w));
    u.searchParams.set('q', String(q));
    u.searchParams.set('fm', 'webp');
    return u.toString();
  }

  // Pexels: add auto compress and width
  if (url.includes('images.pexels.com')) {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}auto=compress&cs=tinysrgb&w=${w}`;
  }

  return url;
}
